import { createAction } from 'redux-actions';

const actions = {
  /**
   * 유저정보 등록하기
   */
  FETCH_USER_DATA: 'app/FETCH_USER_DATA',
  fetchUserData: createAction('app/FETCH_USER_DATA'),
  /**
   * 데이터 변경
   */
  SET_DATA: 'app/SET_DATA',
  setData: createAction('app/SET_DATA'),

  /**
   * 스피너 토글
   */
  SET_FULLSCREEN_LOADER: 'app/SET_FULLSCREEN_LOADER',
  setFullscreenLoader: createAction('app/SET_FULLSCREEN_LOADER'),

  /**
   * 사이드바 토글
   */
  SIDEBAR_TOGGLE_COLLAPSE: 'app/SIDEBAR_TOGGLE_COLLAPSE',
  sidebarToggleCollapse: createAction('app/SIDEBAR_TOGGLE_COLLAPSE'),

  /**
   * 기본적인 정보 가져오기
   */
  GET_COMMON_DATA_REQUEST: 'app/GET_COMMON_DATA_REQUEST',
  GET_COMMON_DATA_SUCCESS: 'app/GET_COMMON_DATA_SUCCESS',
  getCommonData: createAction('app/GET_COMMON_DATA_REQUEST'),
  /**
   * 상품 상세 미리보기 데이터 요청하기
   */
  GET_PRODUCT_PREVIEW_DATA_REQUEST: 'app/GET_PRODUCT_PREVIEW_DATA_REQUEST',
  getProductPreviewData: createAction('app/GET_PRODUCT_PREVIEW_DATA_REQUEST'),

  /**
   * 태그 상세 미리보기 데이터 요청하기
   */
  GET_TAG_PREVIEW_DATA_REQUEST: 'app/GET_TAG_PREVIEW_DATA_REQUEST',
  getTagPreviewData: createAction('app/GET_TAG_PREVIEW_DATA_REQUEST'),

  /**
   * 배송 트래킹 데이터 요청하기
   */
  GET_ORDER_DELIVERY_TRACKING_REQUEST: 'app/GET_ORDER_DELIVERY_TRACKING_REQUEST',
  getOrderDeliveryTrackingData: createAction('app/GET_ORDER_DELIVERY_TRACKING_REQUEST'),

  /**
   * 배송지 변경 이력 데이터 요청하기
   */
  GET_ORDER_DELIVERY_MODIFY_DATA_REQUEST: 'app/GET_ORDER_DELIVERY_MODIFY_DATA_REQUEST',
  getOrderDeliveryModifyData: createAction('app/GET_ORDER_DELIVERY_MODIFY_DATA_REQUEST'),

  /**
   * 기획전 아이템 리스트 모달 토글
   */
  OPEN_EVENT_ITEM_LIST_MODAL: 'app/OPEN_EVENT_ITEM_LIST_MODAL',
  openEventItemListModal: createAction('app/OPEN_EVENT_ITEM_LIST_MODAL'),

  /**
   * 기획전 아이템 리스트 요청하기
   */
  GET_EVENT_ITEM_LIST_REQUEST: 'app/GET_EVENT_ITEM_LIST_REQUEST',
  GET_EVENT_ITEM_LIST_SUCCESS: 'app/GET_EVENT_ITEM_LIST_SUCCESS',
  getEventItemList: createAction('app/GET_EVENT_ITEM_LIST_REQUEST'),

  /**
   * 홈 아이템 리스트 모달 토글
   */
  OPEN_HOME_ITEM_LIST_MODAL: 'app/OPEN_HOME_ITEM_LIST_MODAL',
  openHomeItemListModal: createAction('app/OPEN_HOME_ITEM_LIST_MODAL'),

  /**
   * 상품 공지사항 아이템 리스트 모달 토글
   */
  OPEN_NOTICE_PRODUCT_ITEM_LIST_MODAL: 'app/OPEN_NOTICE_PRODUCT_ITEM_LIST_MODAL',
  openNoticeProductItemListModal: createAction('app/OPEN_NOTICE_PRODUCT_ITEM_LIST_MODAL'),

  /**
   * 상품 공지사항 아이템 리스트 요청하기
   */
  GET_NOTICE_PRODUCT_ITEM_LIST_REQUEST: 'app/GET_NOTICE_PRODUCT_ITEM_LIST_REQUEST',
  GET_NOTICE_PRODUCT_ITEM_LIST_SUCCESS: 'app/GET_NOTICE_PRODUCT_ITEM_LIST_SUCCESS',
  getNoticeProductItemList: createAction('app/GET_NOTICE_PRODUCT_ITEM_LIST_REQUEST'),

  /**
   * 문자 발송 요청하기전 수신자 정보와 관리자 권한 체크하기
   */
  PREPARE_SEND_MESSAGE_SERVICE_REQUEST: 'app/PREPARE_SEND_MESSAGE_SERVICE_REQUEST',
  prepareSendMessageService: createAction('app/PREPARE_SEND_MESSAGE_SERVICE_REQUEST'),

  /**
   * 문자 발송 요청하기
   */
  SEND_MESSAGE_SERVICE_REQUEST: 'app/SEND_MESSAGE_SERVICE_REQUEST',
  sendMessageService: createAction('app/SEND_MESSAGE_SERVICE_REQUEST'),

  /**
   * 모달 토글
   */
  TOGGLE_MODAL: 'app/TOGGLE_MODAL',
  appToggleModal: createAction('app/TOGGLE_MODAL'),

  /**
   * 이미지 임시 저장하기
   */
  ADD_TEMP_IMG_REQUEST: 'app/ADD_TEMP_IMG_REQUEST',
  addTempImg: createAction('app/ADD_TEMP_IMG_REQUEST'),

  /**
   * [쿠폰 발급] 쿠폰 발급 유효성 체크 요청하기
   */
  CHECK_VALID_GENERATE_COUPON_REQUEST: 'app/CHECK_VALID_GENERATE_COUPON_REQUEST',
  checkValidGenerateCoupon: createAction('app/CHECK_VALID_GENERATE_COUPON_REQUEST'),

  /**
   * [쿠폰 발급] 쿠폰 발급 요청하기
   */
  GENERATE_COUPON_REQUEST: 'app/GENERATE_COUPON_REQUEST',
  generateCoupon: createAction('app/GENERATE_COUPON_REQUEST'),

  /**
   * [쿠폰 발급 모달] 발급할 쿠폰 리스트 가져오기
   */
  GET_ISSUED_COUPON_LIST_REQUEST: 'app/GET_ISSUED_COUPON_LIST_REQUEST',
  GET_ISSUED_COUPON_LIST_SUCCESS: 'app/GET_ISSUED_COUPON_LIST_SUCCESS',
  getIssuedCouponList: createAction('app/GET_ISSUED_COUPON_LIST_REQUEST'),

  /**
   * [쿠폰 발급 모달] 검색으로 선택한 쿠폰 리스트 가져오기
   */
  GET_SEARCH_COUPON_RESULT_REQUEST: 'app/GET_SEARCH_COUPON_RESULT_REQUEST',
  GET_SEARCH_COUPON_RESULT_SUCCESS: 'app/GET_SEARCH_COUPON_RESULT_SUCCESS',
  getSearchCouponResult: createAction('app/GET_SEARCH_COUPON_RESULT_REQUEST'),

  /**
   * [포인트 발급] 포인트 발급 유효성 체크 요청하기
   */
  CHECK_VALID_GENERATE_POINT_REQUEST: 'app/CHECK_VALID_GENERATE_POINT_REQUEST',
  checkValidGeneratePoint: createAction('app/CHECK_VALID_GENERATE_POINT_REQUEST'),

  /**
   * [포인트 발급 모달] 포인트 발급 하기
   */
  GENERATE_POINT_REQUEST: 'app/GENERATE_POINT_REQUEST',
  generatePoint: createAction('app/GENERATE_POINT_REQUEST'),

  /**
   *  태그명 유효성 검사하기
   */
  CHECK_TAG_NAME_REQUEST: 'app/CHECK_TAG_NAME_REQUEST',
  checkTagName: createAction('app/CHECK_TAG_NAME_REQUEST'),

  /**
   *  연관된 태그 리스트 요청하기
   */
  GET_RELATED_TAG_LIST_REQUEST: 'app/GET_RELATED_TAG_LIST_REQUEST',
  getRelatedTagList: createAction('app/GET_RELATED_TAG_LIST_REQUEST'),

  /**
   *  반품 요청, 반품 거부, 교환 요청, 교환 거부 이미지 가져오기
   */
  GET_REQUEST_REJECT_ATTACHMENT_DATA_REQUEST: 'app/GET_REQUEST_REJECT_ATTACHMENT_DATA_REQUEST',
  getRequestRejectAttachmentData: createAction('app/GET_REQUEST_REJECT_ATTACHMENT_DATA_REQUEST'),

  /**
   *  해당 브랜드의 상품 리스트 요청하기
   */
  GET_BRAND_PRODUCT_LIST_REQUEST: 'app/GET_BRAND_PRODUCT_LIST_REQUEST',
  GET_BRAND_PRODUCT_LIST_SUCCESS: 'app/GET_BRAND_PRODUCT_LIST_SUCCESS',
  getBrandProductList: createAction('app/GET_BRAND_PRODUCT_LIST_REQUEST'),

  /**
   *  상품 2차 카테고리 리스트 가져오기
   */
  GET_PRODUCT_SUB_CATEGORY_LIST_REQUEST: 'app/GET_PRODUCT_SUB_CATEGORY_LIST_REQUEST',
  getProductSubCategoryList: createAction('app/GET_PRODUCT_SUB_CATEGORY_LIST_REQUEST'),

  /**
   *  구매자 이전 구매내역 데이터 가져오기
   */
  GET_BUYER_PURCHASE_HISTORY_REQUEST: 'app/GET_BUYER_PURCHASE_HISTORY_REQUEST',
  getBuyerPurchaseHistoryData: createAction('app/GET_BUYER_PURCHASE_HISTORY_REQUEST'),

  /**
   * 택배사 리스트 가져오기
   */
  GET_DELIVERY_AGENT_LIST_REQUEST: 'app/GET_DELIVERY_AGENT_LIST_REQUEST',
  getDeliveryAgentList: createAction('app/GET_DELIVERY_AGENT_LIST_REQUEST'),

  /**
   *  카테고리 검색 리스트 요청하기
   */
  GET_PRODUCT_CATEGORY_SEARCH_LIST_REQUEST: 'app/GET_PRODUCT_CATEGORY_SEARCH_LIST_REQUEST',
  GET_PRODUCT_CATEGORY_SEARCH_LIST_SUCCESS: 'app/GET_PRODUCT_CATEGORY_SEARCH_LIST_SUCCESS',
  getItemSearchList: createAction('app/GET_PRODUCT_CATEGORY_SEARCH_LIST_REQUEST'),
};

export default actions;
